import coverImg from "assets/images/v130/cover.webp"
import titleImg from "assets/images/v130/title.webp"
import bottomImg from "assets/images/v130/bottom.webp"

export const v130Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
  bottom: {
    en: bottomImg,
  },
}
